import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import subscriptionResponse from '../../testing/mocks/subscriptions';
import getURLParameters from '../../helpers/getURLParams';
import getPriceData from '../../helpers/getPriceData';
import RollAnimation from '../../helpers/roll-animation';
import {loadStripe} from '@stripe/stripe-js';
import customRequest from '../../helpers/customRequest'
import message from '../../components/message/message';
import Common from '../../context/Common'
import ReactGA from 'react-ga'

import icon3 from '../../content/images/icon-3.png';
import icon4 from '../../content/images/icon-4.png';
import icon5 from '../../content/images/icon-5.png';
import payment_methods from '../../content/images/payment-methods.jpg';

// import initializePriceForm from '../../helpers/forms/price-form';

class Subscribe extends React.Component {

    static contextType = Common

    constructor(props) {
        super(props);

        let loggedIn = true; // ajax/context handler call
        // let hasSubscription = false; // for debugging

        this.state = {
            "students": 1,
            "discount-code": "",
            "training-instructors": 0,
            "cert-instructors": 0,
            discountRequestTimeout: null,
            productPrices: null,
            total: 0,
            shownTotal: 0,
            discountCodeToCheck: null,
            discountCodeValid: null,
            statusElement: "",
            formStatusClass: "",
            extendSubscription: null,
            checkoutId: "",
            redirect: null,
            loggedIn: loggedIn,
            hasSubscription: null,
            submitting: false
        }
    }

    async componentDidMount() {
        // TODO: use price-form script?
        // initializePriceForm();

        var rollAnimationPrice = new RollAnimation();

        var priceContainer = rollAnimationPrice.node;
        priceContainer.id = "price-container";
        var priceGroup = document.getElementById("price-group");
        priceGroup.appendChild(priceContainer);

        var rollAnimationStatus = new RollAnimation();

        var statusContainer = rollAnimationStatus.node;
        statusContainer.id = "status-container";
        statusContainer.style.height = 55;
        var statusGroup = document.getElementById("status-group");
        statusGroup.appendChild(statusContainer);

        this.setDiscountCodeAndUpdate();

                //todo: check login and update state
        //todo: check if there is at least one subscription on profile and update state
        //              ^^^^ in constructor?
        subscriptionResponse().then(async (res)=>{
            let response = await res.json()
            this.setState({hasSubscription: 
                (response?.validSubscriptions?.length ?? 0)
                + (response?.expiredSubscriptions?.length ?? 0) > 0})
        })
        let params = getURLParameters();

        if (params.students) {
            //must be await so that initial price renders on page load
            await this.setState({ students: parseInt(params.students, 10) });
        }

        if (params.discount) {
            this.setState({ "discount-code": params.discount }, this.setDiscountCodeAndUpdate);
        }
        if (params.start && params.exp && params.students && params.created) {
            this.setState({
                extendSubscription: {
                    start: params.start,
                    exp: params.exp,
                    students: params.students,
                    created: params.created
                }
            });
        } else {
            if (this.props.purchaseView === "extend") {
                this.setState({
                    redirect: "/subscribe/extend/summary"
                });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let isLoggedIn = this.context?.auth == "customer"
        if (this.state.loggedIn != isLoggedIn) {
            this.setState({loggedIn: isLoggedIn})
        }
        if (this.state.redirect) return;

        if (Math.abs(prevState.shownTotal - this.state.shownTotal) > .1) {
            var priceContainer = document.getElementById("price-container");
            var rollAnimation = priceContainer.animationObject;
            var priceBlock = document.createElement("p");
            priceBlock.classList.add("form-control-static");
            priceBlock.textContent = "$" + String(this.state.shownTotal.toFixed(2));
            rollAnimation.addState(priceBlock);
        }

        window.$( ".title-question-mark" ).tooltip()
    }

    handleInputChange = (event) => {
        if (this.state.redirect) return;

        const target = event.target;
        const name = target.name;

        let value;
        if (target.type === "checkbox") {
            value = target.checked;
        } else if (target.type === "number") {
            value = parseInt(target.value, 10);
        } else {
            value = target.value;
        }
        
        this.setState({
            [name]: value
        });
        if ((value - this.state[name]) + this.state.students + this.state["training-instructors"] + this.state["cert-instructors"] < 1) return;

        clearTimeout(this.state.discountRequestTimeout);
        this.setState({
            discountRequestTimeout: setTimeout(this.setDiscountCodeAndUpdate, 1000)
        });
    };

    onSubmit = (e)=>{
        e.preventDefault();
        this.setState({submitting: true}, () => {
            let data = {
                'products':{
                    'Reading Subscription': this.state.students,
                    'Training': this.state["training-instructors"],
                    'Verification': this.state["cert-instructors"],
                },
                'discountCode': this.state["discount-code"] ?? "",
                'extendCreated': String(this.state.extendSubscription) ?? ""
            }
            if(!this.state.discountCodeToCheck || this.state.discountCodeValid)
            Promise.all([customRequest.post('/api/transaction/started', data),  loadStripe(process.env.REACT_APP_STRIPE_PUBLICKEY)])
            .then(async ([{data: started}, stripe]) => {
                if (started.valid == false) {
                    this.setState({submitting: false})
                    return message.error(started.message)
                }
                ReactGA.event({
					category: 'digitalCheckout',
					action: 'begin_checkout',
					label: 'button'
                  })
                setTimeout(() => {
                    stripe.redirectToCheckout({
                        sessionId: started['checkoutID']
                        })
                        .catch(() => {
                            message.error("There has been an error starting your transaction.")
                            this.setState({submitting: false})
                        })
                }, 500)
            })
        })
    }

    updatePriceAndDiscountMessage = async () => {
        let priceData = await getPriceData(this.state.students, this.state["training-instructors"], this.state["cert-instructors"], this.state.discountCodeToCheck);

        this.setState({
            shownTotal: priceData.price,
            productPrices: priceData.prices
        });
        if(priceData.messageType != 'error'){
            this.setState({
                discountCodeValid: true
            })
        }
        this.setStatus(priceData.message, priceData.messageType);
    };

    setDiscountCodeAndUpdate = () => {
        this.setState({
            discountCodeToCheck: this.state["discount-code"]
        }, this.updatePriceAndDiscountMessage);
    };

    setStatus = (text, type) => {
        if (type === "clear") {
            var helpContainer = document.getElementById("status-container");
            if (helpContainer != null) {
                var statusElement = document.getElementsByClassName("help-block")[0];
                if (statusElement != null) {
                    statusElement.textContent = "";
                }
                helpContainer.addEventListener("transitionend", window.removeAnimationTarget);
                helpContainer.style.height = "0px";
                helpContainer.style.marginBottom = "0px";
            }

            this.setState({
                formStatusClass: ""
            });
        } else {
            //check if update is necessary
            var statusElementOld = document.getElementsByClassName("help-block")[0];
            if (statusElementOld != null && statusElementOld.textContent === text) {
                return;
            }

            let statusColor = "";
            if (type === "error") statusColor = "#a94442";
            else if (type === "warning") statusColor = "#8a6d3b";
            else if (type === "success") statusColor = "#3c763d";

            // create status element and animate in
            var statusContainer = document.getElementById("status-container");
            var rollAnimation = statusContainer.animationObject;
            var statusElement = document.createElement("label");
            statusElement.classList.add("help-block");
            statusElement.textContent = text;
            statusElement.style.color = statusColor;
            rollAnimation.addState(statusElement);

            this.setState({
                formStatusClass: "has-" + type
            });
        }
    };

    // Element functions to be rendered conditionally

    ExtendHeader = () => {
        return (
            <React.Fragment>
                <h1>Extend Subscriptions</h1>
                <div class="row subheader-text">
                    <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>To extend this subscription by one year with the existing {this.state.extendSubscription.students} number of students that expires on {this.state.extendSubscription.exp}, make the appropriate selection below. </p>
                        <p>If you want to change the student count of this extended subscription, please edit the value in Number of Students. Please note that this new student count will not change until after this selected subscription expires.</p>
                    </div>
                </div>
            </React.Fragment>
        )
    };

    AddHeader = () => {
        return (
            <React.Fragment>
                <h1>Add Students</h1>

                <div class="row subheader-text">
                    <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Select the number of students you would like to add below.</p>
                    </div>
                </div>

            </React.Fragment>
        )
    };

    DefaultHeader = () => {
        return (
            <React.Fragment>
                <h1>Subscribe to Great Leaps Digital</h1>

                <div class="row subheader-text">
                    <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <h2>90 Day <b>Risk Free</b> Guarantee<span class="title-question-mark" data-toggle="tooltip" data-placement="top" title="We are confident your student will have incredible results but if you use Great Leaps Digital as instructed for an average of 3 days per week for 90 days and aren’t satisfied, we’ll give you your money back!" /></h2>
                        {!this.state.loggedIn && (
                            <React.Fragment>
                                <br />

                                <p>Not ready to subscribe just yet?</p>
                                <div class="offset-lg-4 col-lg-4">
                                    <button class="btn btn-lg btn-secondary"><Link class="link-unstyled" to="/account/sign-up"><strong>FREE TRIAL</strong></Link></button>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </React.Fragment>
        )
    };

    LoggedOutLinks = () => {
        return (
            <React.Fragment>
                <div class="row">
                    <div class="col-sm-6 offset-sm-3">
                        <Link to="/account/log-in/teacher" class="btn btn-secondary btn-lg">Log In to Purchase</Link>
                    </div>
                </div>

                <div class="row">
                    <span class="center-block">OR</span>
                </div>

                <div class="row">
                    <div class="col-sm-4 offset-sm-4">
                        <Link to="/account/sign-up" class="btn btn-secondary btn-lg">Sign Up for Your Account</Link>
                    </div>
                </div>
            </React.Fragment>
        )
    };

    LoggedInLinks = () => {

        // todo: connect paypal stuff

        let checkoutButton = (<button id="paypal-submit" type="submit" name="paypal-submit" value="submit" class="btn btn-secondary btn-lg" disabled={this.state.submitting}>Complete Checkout</button>);
        if (this.props.purchaseView === "extend") {
            checkoutButton = (<button type="button" class="btn btn-secondary btn-lg" data-toggle="modal" data-target="#warning-modal" disabled={this.state.submitting}>Complete Checkout</button>);
        }

        return (
            <React.Fragment>
                {checkoutButton}

                <img src={payment_methods} alt="Payment Methods" />

                <div class="row subheader-text">
                    <div class="col-sm-6 offset-sm-3">
                        <hr class="strong inline" />

                        <p>Or</p>

                        <hr class="strong inline" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <Link to={"/subscribe/purchase-order?students=" + this.state.students + "&training=" + this.state["training-instructors"] + "&certification=" + this.state["cert-instructors"] + "&discount=" + this.state["discount-code"]}><button  class="btn btn-secondary btn-lg">Pay with Purchase Order</button></Link>
                        {/*<button id="purchase-order-submit" type="submit" name="purchase-order-submit" value="submit" class="btn btn-secondary btn-lg">Pay with Purchase Order</button>*/}
                    </div>
                </div>

                {this.props.purchaseView === "extend" && (
                    <div class="modal fade" id="warning-modal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Warning</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-left">
                                    <p>Please note that this new student count will not change from {this.state.extendSubscription != null && this.state.extendSubscription.students}
                                        until after this selected subscription expires on {this.state.extendSubscription != null && this.state.extendSubscription.exp}. If you need to
                                        immediately add students to a subscription, please use the <Link to="/subscribe/extend/summary" onClick={() => window.$("#warning-modal").modal("hide")}>Manage Subscriptions</Link> screen to add students.
                                    </p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn modal-btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button type="submit" name="paypal-submit" value="submit" class="btn modal-btn btn-secondary button-inline">Buy</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </React.Fragment>
        )
    };

    render() {

        //TODO: move to component that handles validation logic before rendering a subscribe purchase page
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        if (this.props.purchaseView === "default") {
            if (this.state.loggedIn && this.state.hasSubscription) {
                this.setState({
                    redirect: "/subscribe/choose"
                });
            }
        }

        //begin actual render

        let header;
        if (this.props.purchaseView === "extend" && this.state.extendSubscription != null) header = <this.ExtendHeader />;
        else if (this.props.purchaseView === "add") header = <this.AddHeader />;
        else header = <this.DefaultHeader />;

        let purchaseButtons = this.state.loggedIn ? <this.LoggedInLinks /> : <this.LoggedOutLinks />;

        return (
            <React.Fragment>
                <link rel="stylesheet" type="text/css" href="/styles/subscribe.css" />

                {header}
                <p>Great Leaps Digital is a one-on-one program. A caring instructor is essential for student success.</p>
                <form class="form-horizontal" id="form-subscribe" method="post" onSubmit={this.onSubmit}>
                    <h1 class="section-header text-left"><strong>Programs</strong></h1>

                    <div class="row">
                        <div class="offset-sm-4  col-sm-4 card">
                            <h2 className="mt-3"><strong>Reading</strong></h2>
                            <img className="ml-auto mr-auto" src={icon3} height="200px" width="200px" />

                            <ul class="text-left">
                                <li>Complete access to exercises in phonics, high frequency word phrases, and age appropriate stories with depth of knowledge questions</li>
                                <li>Student data is recorded, interpreted for you and kept and accessible at any time even after your subscription expires</li>
                                <li>Built in sharing and transferring feature to enable administrative oversight and better ensure fidelity with instructors</li>
                            </ul>
                            <h2>Annual Subscription</h2>
                            <p>Contact us for group pricing at <br /><a href="tel:877-475-3277">877-475-3277</a></p>

                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="annual-label">${this.state.productPrices?.students}/student</h3>
                                </div>

                                {/* <div class="col-md-6 hidden">
                                    <div id="price-under-5" class="price-label btn btn-secondary btn-md no-top-margin active">
                                        1-4 Students<br />
                                        <span class="annual-label">$129/student</span>
                                        <span class="monthly-label hidden">$25/student</span>
                                    </div>
                                </div>
                                <div class="col-md-6 hidden">
                                    <div id="price-over-5" class="price-label btn btn-secondary btn-md no-top-margin">
                                        <span class="annual-label">5+ Students<br />$59/student</span>
                                        <span class="monthly-label hidden">5+ Students<br />$20/student</span>
                                    </div>
                                </div> */}
                            </div>

                            <div class="form-group row">
                                <label for="students" class="d-none d-lg-block col-sm-3 control-label text-right">Students</label>

                                <div class="col-lg-6">
                                    <input type="number" class="form-control" id="students" name="students" min="0" max="65535" step="1" value={this.state["students"]} onChange={this.handleInputChange} required data-description="enter your number of students" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h1 class="section-header text-left"><strong>Extras</strong></h1>

                    <div class="row display-flex">
                        <div class="col-sm-5 offset-sm-1 card training-card">
                            <h2 className="mt-3"><strong>Training</strong></h2>
                            <img className="mr-auto ml-auto" src={icon5} height="200px" width="200px" />

                            <ul class="text-left">
                                <li>Individual or small group training for teachers and tutors preparing to implement Great Leaps for groups of up to 3 instructors</li>
                                <li>Includes 3 - hours of online training from a specialist, individualized Verification (below), and a digital certificate of approval</li>
                                <li>Includes procedures, teaching methods, motivational techniques, data analysis, and more</li>
                            </ul>
                                <p>Contact us for group pricing at <br /><a href="tel:877-475-3277">877-475-3277</a></p>
                                <small>* You will be contacted for scheduling training sessions immediately after purchase</small>
                                <h2><strong>${this.state.productPrices?.training}/Instructor</strong></h2>
                                <div class="form-group row">
                                    <label for="training-instructors" class="d-none d-lg-block col-sm-3 control-label text-right">Instructors</label>

                                    <div class="col-lg-6">
                                        <input type="number" class="form-control" id="training-instructors" name="training-instructors" min="0" max="65535" step="1" value={this.state["training-instructors"]} onChange={this.handleInputChange} required data-description="enter your number of instructors" />
                                    </div>
                                </div>
                        </div>

                        <div class="col-sm-5 offset-sm-1 card verification-card">
                        <h2 className="mt-3"><strong>Verification</strong></h2>
                            <img className="mr-auto ml-auto" src={icon4} height="200px" width="200px" />

                            <ul class="text-left">
                                <li>For proficient Great Leaps tutors and teachers who work with fidelity and would like to be officially verified</li>
                                <li>Submit a video of a complete tutoring session for evaluation and receive a signed certificate upon your approval</li>
                                <li>Included in our Training package and limited to one submission</li>
                            </ul>
                            
                            <div class="subscribe-card-bottom">
                                <p>Contact us for group pricing at <br /><a href="tel:877-475-3277">877-475-3277</a></p>
                                <small>* You will be contacted regarding details for your video and how to submit it for approval</small>
                                <h2><strong>${this.state.productPrices?.verification}/Instructor</strong></h2>
                                <div class="form-group row">
                                    <label for="username" class="d-none d-lg-block col-sm-3 control-label text-right">Instructors</label>

                                    <div class="col-lg-6">
                                        <input type="number" class="form-control" id="cert-instructors" name="cert-instructors" min="0" max="65535" step="1" value={this.state["cert-instructors"]} onChange={this.handleInputChange} required data-description="enter your number of certification" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class={"form-group prefooter-text row " + this.state.formStatusClass}>
                        <label for="discount-code" class="col-12 col-sm-3 offset-md-1 offset-lg-1_5 col-xl-offset-2 control-label text-right">Discount Code</label>

                        <div class="col-xxs-12 col-xxs-offset-0 col-6 offset-3 offset-sm-0 col-md-3">
                            <input type="text" class="form-control string" id="discount-code" name="discount-code" value={this.state["discount-code"]} onChange={this.handleInputChange} placeholder="Code" minlength="1" maxlength="175" data-description="enter a discount code" data-amount="0" data-code-type="fixed" data-minimum="0" data-maximum="0" />

                        </div>
                        <div class="row">
                            <div id="status-group" class="col-xxs-12 col-xxs-offset-0 col-6 offset-3 offset-sm-3 offset-md-3 col-md-6">

                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-6 control-label text-right radio bold text-right">Total:</label>

                        <div id="price-group" class="col-6 text-left">
                        </div>
                        {/* <p class="monthly-label hidden"><strong>*Monthly subscriptions are automatically enrolled in auto-renewal</strong></p> */}
                    </div>

                    <div class="row">
                        <div class="subscribe-submit col-12">
                            <div class="form-group absolute invisible" id="offline-purchase">
                                <div class="vertical-align-dummy d-none d-lg-block"></div>

                                <div>
                                    <p>Purchase orders are accepted.</p>

                                    <p>Contact us using our <a href="https://greatleaps.com/index.php?main_page=contact_us">contact form</a> for a quote and full payment options.</p>
                                </div>
                            </div>

                            <div class="form-group row" id="online-purchase">

                            </div>
                        </div>
                    </div>

                    {purchaseButtons}

                    <div class="form-group prefooter-text">
                        <div class="col-12">
                            <p class="d-block d-sm-none spacing-line"></p>

                            <p>If you have any problems purchasing a Great Leaps Digital subscription, please reach out with our <a href="https://greatleaps.com/index.php?main_page=contact_us">contact form</a>.</p>
                        </div>
                    </div>
                </form>

            </React.Fragment>
        )
    }
}

export default Subscribe;
